import dayjs from "dayjs";

import { MobileTimePicker as MUITimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Custom } from "components";

type Props = {
  label: string;
  value: string; // formatted "hh:mm A"
  onChange: (value: string) => void;
};

export const TimePicker = ({ label, value, onChange }: Props) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MUITimePicker
        label={label}
        value={value ? dayjs(value, "hh:mm A") : null} // parse correctly
        onChange={(newValue) => {
          if (newValue) {
            onChange(newValue.format("hh:mm A")); // format back to string
          }
        }}
        renderInput={(params) => <Custom.TextField {...params} />}
      />
    </LocalizationProvider>
  );
};
